import { EventParticipant } from 'src/modules/event/models/eventParticipant';
import { EventParticipantPutRequest, EventParticipantRequest } from 'src/modules/event/models/eventParticipantRequest';
import { EventParticipantTicket } from 'src/modules/event/models/eventParticipantTicket';
import { MemberEmail } from 'src/modules/member/models/memberEmail';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'EventParticipant';

export const getAllEventParticipants = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<EventParticipant>>(endpoint);
};

export const getEventParticipantById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<EventParticipant>(endpoint);
};

export const createEventParticipant = (data: EventParticipantRequest) => {
  return AxiosInstance.post(controller, data);
};

export const updateEventParticipant = (data: EventParticipantPutRequest) => {
  return AxiosInstance.put<EventParticipant>(controller, data);
};

export const deleteEventParticipantById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};

export const deleteEventParticipantList = (ids) => {
  const endpoint = `${controller}/DeleteList`;
  return AxiosInstance.delete(endpoint, { data: ids });
};

export const getEventParticipantEmailLog = (participantId: number) => {
  return AxiosInstance.get<PagedResult<MemberEmail>>(`${controller}/${participantId}/Email`);
};

export const getEventParticipantTickets = (participantId: number) => {
  return AxiosInstance.get<EventParticipantTicket[]>(`${controller}/${participantId}/Tickets`);
};

export const getEventParticipantLog = (participantId: number) => {
  // eslint-disable-next-line camelcase
  return AxiosInstance.get<Array<{ eventParticipantLog_id: number; eventParticipant_id: number; message: string; createdAt: string }>>(
    `${controller}/${participantId}/Log`,
  );
};
